import React, { useEffect, useState } from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../assets/me.png'
import HeaderSocial from './HeaderSocials'

const Header = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100,
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <header id="home">
      {/* Background particles */}
      <div className="particles">
        <div className="particle particle-1"></div>
        <div className="particle particle-2"></div>
        <div className="particle particle-3"></div>
        <div className="particle particle-4"></div>
        <div className="particle particle-5"></div>
      </div>
      
      {/* Interactive background gradient */}
      <div 
        className="interactive-bg"
        style={{
          background: `radial-gradient(circle at ${mousePosition.x}% ${mousePosition.y}%, rgba(77, 181, 255, 0.1) 0%, transparent 50%)`
        }}
      ></div>

      <div className="container header__container">
        <div className="header__content">
          <div className="header__text">
            <span className="header__greeting">
              <span className="greeting-icon">👋</span>
              Hello, I'm
            </span>
            <h1 className="header__name">
              <span className="name__highlight">Al-Mustapha</span> Sulaiman
            </h1>
            <h2 className="header__title">
              <span className="typing-animation">Fullstack Developer</span>
            </h2>
            <p className="header__description">
              Passionate about creating innovative web solutions that bridge the gap between 
              design and functionality. I build modern, responsive applications using cutting-edge technologies.
            </p>
            
            {/* Skills badges */}
            <div className="skills-preview">
              <span className="skill-badge">React</span>
              <span className="skill-badge">Node.js</span>
              <span className="skill-badge">TypeScript</span>
              <span className="skill-badge">Python</span>
            </div>
            
            <CTA />
          </div>
          
          <div className="header__image">
            <div className="image__background">
              <div className="floating__elements">
                <div className="floating__element element-1"></div>
                <div className="floating__element element-2"></div>
                <div className="floating__element element-3"></div>
                <div className="floating__element element-4"></div>
                <div className="floating__element element-5"></div>
              </div>
              
              {/* Image container with enhanced styling */}
              <div className="me">
                <div className="image-border"></div>
                <img src={ME} alt="Al-Mustapha Sulaiman - Fullstack Developer" />
                <div className="image-overlay"></div>
              </div>
              
              {/* Status indicator */}
              <div className="status-indicator">
                <div className="status-dot"></div>
                <span>Available for work</span>
              </div>
            </div>
          </div>
        </div>

        <HeaderSocial />
        
        {/* Ultra-modern scroll down indicator */}
        <div className='scroll__down-container'>
          <a href="#about" className='scroll__down'>
            <div className="scroll__text">
              <span className="scroll__explore">Explore</span>
              <span className="scroll__journey">My Journey</span>
            </div>
            <div className="scroll__indicator">
              <div className="scroll__mouse">
                <div className="scroll__dot"></div>
              </div>
              <div className="scroll__chevrons">
                <div className="scroll__chevron"></div>
                <div className="scroll__chevron"></div>
                <div className="scroll__chevron"></div>
              </div>
            </div>
          </a>
          <div className="scroll__progress">
            <div className="scroll__progress-bar"></div>
            <div className="scroll__percentage">0%</div>
          </div>
          <div className="scroll__hint">
            <span>Discover more below</span>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
